/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import CommentSection from "../../../info-technology-process/commentsection/comment-sections";
import { useSelector } from "../../../../../store/store";
import { Skeleton, Form, Input } from "antd";
import { useGetDetailRequests } from "../hooks";
import { useEmployee } from "../../../../../hook";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { requestStatus } from "../../../../../constants";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { StyledTitle } from "../../../../../components/styled-antd/Title";
import { DETAIL } from "../constant";
import { getEmployeeDetail } from "../utils/get-employee-detail";

export const ExportHistory: FC<{ form: any; isEnableAccept: boolean }> = ({
  form,
  isEnableAccept,
}) => {
  const user = useSelector((state) => state.user);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { data: detail, isLoading: isLoadingDetail } = useGetDetailRequests();
  const { data: employees, isLoading: isLoadingEmployees } = useEmployee();

  if (isLoadingDetail || isLoadingEmployees) return <Skeleton />;

  return (
    <>
      <Box title="Lịch sử phê duyệt">
        <div className="py-2 pl-3">
          <p>
            <span className="font-weight-bold">
              {detail?.createdBy?.user?.displayName}
            </span>{" "}
            đã tạo lúc {getDDMMYYYFormat(detail?.createdDateTime)} -{" "}
            {getHHmmFormat(detail?.createdDateTime)}
          </p>
        </div>

        {DETAIL.progress.map((value) => {
          if (value.step == 1) {
            return (
              <>
                {detail?.fields?.eApprovedStatus === requestStatus.approved && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedBy,
                            employees,
                            softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã phê duyệt lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedDate)} -{" "}
                      {getHHmmFormat(detail?.fields?.eApprovedDate)}
                      {detail.fields.eApprovalComment && (
                        <>,{" " + detail.fields.eApprovalComment}</>
                      )}
                    </p>
                  </div>
                )}

                {detail?.fields?.eApprovedStatus === requestStatus.rejected && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedBy,
                            employees,
                          softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã từ chối lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedDate)} -{" "}
                      {getHHmmFormat(detail?.fields?.eApprovedDate)}
                      {detail.fields.eApprovalComment && (
                        <>,{" " + detail.fields.eApprovalComment}</>
                      )}
                    </p>
                  </div>
                )}
              </>
            );
          }
          if (value.step == 2) {
            return (
              <>
                {detail?.fields?.eApprovedByITLeadStatus ===
                  requestStatus.approved && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedByITLead,
                            employees,
                          softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã phê duyệt lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedByITLeadDate)}{" "}
                      - {getHHmmFormat(detail?.fields?.eApprovedByITLeadDate)}
                      {detail.fields.eITLeadComment && (
                        <>,{" " + detail.fields.eITLeadComment}</>
                      )}
                    </p>
                  </div>
                )}

                {detail?.fields?.eApprovedByITLeadStatus ===
                  requestStatus.rejected && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedByITLead,
                            employees,
                         softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã từ chối lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedByITLeadDate)}{" "}
                      - {getHHmmFormat(detail?.fields?.eApprovedByITLeadDate)}
                      {detail.fields.eITLeadComment && (
                        <>,{" " + detail.fields.eITLeadComment}</>
                      )}
                    </p>
                  </div>
                )}
              </>
            );
          }
          if (value.step == 3) {
            return (
              <>
                {detail?.fields?.eApprovedByITHeadStatus ===
                  requestStatus.approved && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedByITHead,
                            employees,
                          softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã phê duyệt lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedByITHeadDate)}{" "}
                      - {getHHmmFormat(detail?.fields?.eApprovedByITHeadDate)}
                      {detail.fields.eITHeadComment && (
                        <>,{" " + detail.fields.eITHeadComment}</>
                      )}
                    </p>
                  </div>
                )}

                {detail?.fields?.eApprovedByITHeadStatus ===
                  requestStatus.rejected && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eApprovedByITHead,
                            employees,
                            softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã từ chối lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eApprovedByITHeadDate)}{" "}
                      - {getHHmmFormat(detail?.fields?.eApprovedByITHeadDate)}
                      {detail.fields.eITHeadComment && (
                        <>,{" " + detail.fields.eITHeadComment}</>
                      )}
                    </p>
                  </div>
                )}
              </>
            );
          }
          if (value.step == 4) {
            return (
              <>
                {detail?.fields?.eAssigneeStatus === requestStatus.approved && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eAssignee,
                            employees,
                          softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã phê duyệt lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eAssigneeStatusDate)} -{" "}
                      {getHHmmFormat(detail?.fields?.eAssigneeStatusDate)}
                      {detail.fields.eAssigneeComment && (
                        <>,{" " + detail.fields.eAssigneeComment}</>
                      )}
                    </p>
                  </div>
                )}

                {detail?.fields?.eAssigneeStatus === requestStatus.rejected && (
                  <div className="py-2 pl-3">
                    <p>
                      <span className="font-weight-bold">
                        {value.title},{" "}
                        {
                          getEmployeeDetail(
                            detail?.fields?.eAssignee,
                            employees,
                        softwares
                          )?.[0]?.Title
                        }
                      </span>{" "}
                      đã từ chối lúc{" "}
                      {getDDMMYYYFormat(detail?.fields?.eAssigneeStatusDate)} -{" "}
                      {getHHmmFormat(detail?.fields?.eAssigneeStatusDate)}
                      {detail.fields.eAssigneeComment && (
                        <>,{" " + detail.fields.eAssigneeComment}</>
                      )}
                    </p>
                  </div>
                )}
              </>
            );
          }
        })}

        <Form form={form}>
          <Form.Item name="comment">
            <StyledTitle level={5}>Comments</StyledTitle>
            <Input.TextArea
              onChange={(e) => {
                form.setFieldsValue({
                  comment: e.target.value,
                });
              }}
              disabled={!isEnableAccept}
            />
          </Form.Item>
        </Form>
      </Box>

      <Box title="Thông tin trao đổi">
        <CommentSection
          comments={[]}
          data={detail}
          user={user}
          id={17}
          className="mb-4"
        />
      </Box>
    </>
  );
};
